export default __webpack_public_path__ + "static/media/agency-lg-1.c3316901.webp";